module.exports = __webpack_public_path__ + "img/home_business_1.2fb5d5ba.png";